export default "__VITE_ASSET__6835b7f8__"